module.exports = __webpack_public_path__ + "img/f_5.ebe3a572.jpg";